export enum StatusFeedback {
  WAITING = 'Waiting',
  COMPLETED = 'Completed'
}

export enum UserFeedbackType {
  NEED_FEEDBACK = 'userRequest',
  FEEDBACK = 'user'
}
